import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ARService} from '../../ar.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ARLedgerTableColumn} from '../../models/ar-ledger-table.model';
import {DataARLedgerModel} from '../../../../models/accountsReceivable/data-ar-ledger.model';
import {Globals} from '../../../../globals';
import {LocalStorageService} from '../../../../services/local-storage.service';

@Component({
  standalone: false,
  selector: 'app-ar-ledger-table-layout-manager',
  templateUrl: './ar-ledger-table-layout-manager.component.html',
  styleUrls: ['./ar-ledger-table-layout-manager.component.scss']
})
export class ArLedgerTableLayoutManagerComponent implements OnInit {

  isLoading: boolean = false;
  displayedTableLayout: ARLedgerTableColumn[] = [];
  displayedTableLayoutBackup: ARLedgerTableColumn[] = [];
  displayedTableLayoutString: string;

  constructor(
    public dialogRef: MatDialogRef<ArLedgerTableLayoutManagerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private arService: ARService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private globals: Globals,
    private localStorageService: LocalStorageService,
  ) { }

  ngOnInit(): void {
    this.displayedTableLayoutBackup = this.data.displayedTableLayout;
    this.displayedTableLayoutBackup.forEach(a => {
      const row = new ARLedgerTableColumn();
      row.headerName = a.headerName;
      row.showColumn = a.showColumn;
      row.colspan = a.colspan;
      row.matColumnDef = a.matColumnDef;
      row.dataColumnName = a.dataColumnName;
      row.isGroupColumn = a.isGroupColumn;
      row.childColumns = a.childColumns;
      this.displayedTableLayout.push(row);
    });
    this.init();
  }

  async init() {
  }

  async save() {

    try {
      this.isLoading = true;

      // serialize column array
      this.displayedTableLayoutString = JSON.stringify(this.displayedTableLayout);
      this.globals.currentLedgerTableLayout = this.displayedTableLayout;

      // save to db
      this.saveFilterParamsToDB();

      this.close(this.displayedTableLayout);
    } catch (err) {
      this.isLoading = false;
      this.createMessage('Something went wrong', 'Error');
      this.close(false);
    }

  }

  close(payload) {
    this.dialogRef.close(payload);
  }

  createMessage(message, type) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  copyToChildren(index: number) {
    this.displayedTableLayout[index].childColumns.forEach(a => {
      a.showColumn = this.displayedTableLayout[index].showColumn;
    });
  }

  copyChildrenToParent(index: number) {
    let numFalse: number = 0;
    let numTrue: number = 0;
    this.displayedTableLayout[index].childColumns.forEach(a => {
      if (!a.showColumn) {
        numFalse = numFalse + 1;
      }
      else {
        numTrue = numTrue + 1;
      }
    });

    // if all child columns are false, then deselect the parent as well
    if (numFalse === this.displayedTableLayout[index].childColumns.length) {
      this.displayedTableLayout[index].showColumn = false;
    }
    else {
      this.displayedTableLayout[index].showColumn = true;
    }
  }

  saveFilterParamsToDB() {
    const userId = this.localStorageService.currentUserData.authdata.userid;
    this.arService.saveUserParams(this.displayedTableLayoutString, userId, 'LedgerTableColumnLayout').subscribe(saved => {
      if (saved)
      {
        // save successful
        this.createMessage('Table settings saved', 'Success');
      }
    }, err => {
      this.createMessage('Error saving tilter settings', 'Error');
    });
  }
}
